import { all, fork } from 'redux-saga/effects';
import {
  watchGetProjectByIdSaga,
  watchUpdateProjectPhaseDatesSaga,
  watchAddMemberToProjectSaga,
  watchRemoveMemberFromProjectSaga,
  watchUpdateProjectMembersSaga,
  watchCreateAndInviteProjectMembers,
  watchProjectTimelineSaga,
  watchDateShiftSaga,
} from './sagas';

export const projectRootSaga = function* () {
  yield all([
    fork(watchGetProjectByIdSaga),
    fork(watchUpdateProjectPhaseDatesSaga),
    fork(watchAddMemberToProjectSaga),
    fork(watchRemoveMemberFromProjectSaga),
    fork(watchUpdateProjectMembersSaga),
    fork(watchCreateAndInviteProjectMembers),
    fork(watchProjectTimelineSaga),
    fork(watchDateShiftSaga),
  ]);
};

export * from './hooks';
